export default function Footer() {
  return (
    <footer className="attribution">
      Challenge by{" "}
      <a
        href="https://www.frontendmentor.io?ref=challenge"
        target="_blank"
        rel="noreferrer"
      >
        Frontend Mentor
      </a>
      . Coded by <a href="https://github.com/eeels22">En-Chi Liu</a>.
    </footer>
  );
}
